/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { BADGE_TYPE_OUTLINE, Badge, BadgeProps } from '@squiz/sds';
import {
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_CANARY,
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_DEDICATED,
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_DEVELOPMENT,
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_EVALUATION,
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_INTERNAL,
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_PRODUCTION,
} from 'apps/console-core/src/Services/console';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MATRIX_ENVIRONMENT_LABELS } from './EnvironmentBadge.constants';
import { EnvironmentBadgeProps } from './EnvironmentBadge.props';

/**
 * A <Badge /> to display the environment of an instance.
 */
export const EnvironmentBadge = (props: EnvironmentBadgeProps): JSX.Element => {
  const { t } = useTranslation();
  const { environment } = props;
  const badgeClass = clsx(`status-badge--environment`, `environment--${environment}`);

  const textByStatus = {
    [CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_CANARY]: ``,
    [CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_DEDICATED]: ``,
    [CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_DEVELOPMENT]: t(MATRIX_ENVIRONMENT_LABELS.development),
    [CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_EVALUATION]: ``,
    [CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_INTERNAL]: ``,
    [CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_PRODUCTION]: t(MATRIX_ENVIRONMENT_LABELS.production),
  };

  const badgeProps: BadgeProps = {
    left: textByStatus[environment],
    type: BADGE_TYPE_OUTLINE,
  };

  return (
    <div className={badgeClass}>
      <Badge {...badgeProps} />
    </div>
  );
};
